import { useEffect } from 'react'
import { getElByHash } from '@seasonedsoftware/utils'

export default hash => {
  const scroll = top => window.scrollTo({ top, behavior: 'smooth' })

  useEffect(() => {
    const el = getElByHash()
    if (el) {
      scroll(el.offsetTop - 100)
    }
  }, [hash])
}
